<template>
  <div class="recordings-detail-container" :class="{ 'is-expanded': expanded }">
    <component
      :is="currentContent"
      :recording="recordingObj"
      :expanded="expanded"
      @toMainMenuChild="toMainMenu"
      @toggle-expand="$emit('toggle-expand')"
    />
  </div>
</template>

<script>
import RecordingResults from "./RecordingResults.vue";
import RecordingDetails from "./RecordingDetails.vue";
import RecordingBlank from "./RecordingBlank.vue";
import AddTester from "./AddTester.vue";
import RecordingView from "./RecordingView.vue";

export default {
  name: 'RecordingDetailsContainer',
  props: {
    contentType: String,
    recordingObj: Object,
    expanded: { type: Boolean, default: false },
  },
  components: {
    RecordingResults,
    RecordingDetails,
    RecordingBlank,
    RecordingView,
    AddTester,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    currentContent() {
      switch (this.contentType) {
        case 'viewer':
          return 'RecordingView';
        case 'details':
          return 'RecordingDetails';
        case 'testers':
          return 'AddTester';
        case 'results':
          return 'RecordingResults';
        default:
          return 'RecordingBlank';
      }
    },
  },
  methods: {
    toMainMenu() {
    },
  },
};
</script>

<style scoped>

/* ── CONTAINER ── */
.recordings-detail-container {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 75vh;
  overflow-y: scroll;
  overflow-x: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
}

.recordings-detail-container.is-expanded {
  height: 90vh;
}

/* ── SCROLLBAR ── */
/* Scrollbar styles inherited from global App.vue */

</style>


// WEBPACK FOOTER //
// src/components/game-detail/Recordings/RecordingDetailsContainer.vue